// extracted by mini-css-extract-plugin
module.exports = {"description":"DisclaimerModal_description__9QycL","rotation":"DisclaimerModal_rotation__xpPPQ"};